import { pipe } from 'fp-ts/lib/function';
import { SelectOption } from 'modules/queryBuilder/contexts';
import { useFilterMessageTypeSubscriptionsFromOptions } from './useFilterMessageTypeSubscriptionsFromOptions';
import { useFilterNonUnsubscribedMessageTypesFromOptions } from './useFilterNonUnsubscribedMessageTypesFromOptions';

export const useFilterOptionsWithFeatureFlags = (options: SelectOption<string>[]) => {
  const filterMessageTypeSubscriptionsFromOptions = useFilterMessageTypeSubscriptionsFromOptions();
  const filterUnsubscribedMessageTypesFromOptions =
    useFilterNonUnsubscribedMessageTypesFromOptions();

  return pipe(
    options,
    filterMessageTypeSubscriptionsFromOptions,
    filterUnsubscribedMessageTypesFromOptions,
  );
};
